import { NuisibleManagement } from '@repo/ui/features/nuisibles/index';

export default function NuisiblesPage() {
  return (
    <div className="">
      <NuisibleManagement />
    </div>
  );
}
